import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'alen.lde.billing_tourdate.1101.no-pauschal',
  label: 'Bulky',
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.custom,
  category: 'abrechnungen',
  description: '',
  definition: getDefinitionByName('Bulky'),
});
